import {Component, Inject, Input, OnInit, Optional, Self, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from '../base-answer-type.component';
import {FileDto} from '../../../../models/file';
import {PublicFilesService} from '../../../../services/public-files.service';
import {MatTableDataSource, MatTable} from '@angular/material/table';
import {ComparableOperator} from '../../../../models/form';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SimpleFileUploaderComponent } from '@app/views/pages/simple-file-uploader/simple-file-uploader.component';

@Component({
  selector: 'app-files-input',
  templateUrl: './files-input.component.html',
  styleUrls: ['./files-input.component.scss'],
})
export class FilesInputComponent extends BaseAnswerTypeComponent<number[]> implements OnInit {

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data?: FilesInputComponent,
    @Optional()
    private dialogRef?: MatDialogRef<FilesInputComponent>,
    @Optional() @Self() ngControl?: NgControl,
    private uploadFileService?: PublicFilesService,
  ) {
    super(ngControl);
  }
  @Input() maxLength = 200;
  @Input() placeholder = '';
  @Input() label = '';

  @Input() initialData: FileDto[];

  @Input() uploadEndpoint: string;

  @Input() allowedExtensions = '.png,.jpg,.jpeg,.pdf,.docx,.xls,.xlsx,.webp,.webm';
  @ViewChild('fileUploader') fileUploader: SimpleFileUploaderComponent;
  filesData: Partial<FileDto>[] = [];

  isDialog: boolean = false;
  readOnly: boolean = true;

  displayedColumns = [
    'name',
    'type',
    'size',
    'remove',
  ];
  // static defaultValue = [-1];
  matDatasource = new MatTableDataSource([]);

  AllowedOperators: {[K in ComparableOperator]: (t: number[], value: any) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target) => !target?.length,
    [ComparableOperator.NotIsNullOrEmpty]: (target) => !! target?.length,
    [ComparableOperator.Between]: null,
  };

  ngOnInit() {
    if (!this.uploadEndpoint) {
      this.uploadEndpoint = `FileStorage/UploadFileFormAnswerTypeAttachment`
    } else {
      this.uploadEndpoint = this.uploadEndpoint;
    }
  }


  ngAfterViewInit() {

    this.matDatasource.data = this.initialData;

    if (this.data) {
      this.isDialog = true;
      this.matDatasource.data = this.data.initialData;
      this.uploadEndpoint = this.data.uploadEndpoint;
      this.allowedExtensions = this.data.allowedExtensions;
      this.readOnly = this.data.readOnly;
      this.label = this.data.label;
    }

    this.fileUploader.rawFiles = this.matDatasource.data;

    if (this.dialogRef) {
      this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.matDatasource.data));
    }

    if (!this.isDialog) {
      super.ngAfterViewInit();
    }

    this.fileUploader.changes.subscribe(files => {
      // console.log(files);
      if (!this.isDialog) {
        this.updateValue(files.map(f => f.id));
      }
      
      this.matDatasource.data = [...files];
      console.log(this.matDatasource.data);
    });
  }

  onDismiss() {
    this.dialogRef.close(this.matDatasource.data);
  }


}
